import type {
  GetApiPayloadByUrl,
  GetApiResponseByUrl,
} from '@crossbeam/openapi';

export type Webhook = GetApiResponseByUrl<'/v0.1/webhooks'>[number];
export type Signal =
  GetApiResponseByUrl<'/v1/signals/accounts'>['data'][number];

// Webhook payload types
export type WebhookPostPayload = GetApiPayloadByUrl<'/v0.1/webhooks', 'post'>;

export type WebhookPatchPayload = GetApiPayloadByUrl<
  '/v0.1/webhooks/{webhook_id}',
  'patch'
>;

export type WebhookConfigurationPayload = GetApiPayloadByUrl<
  '/v0.1/webhooks/{webhook_id}/configuration',
  'post'
>;

// Webhook secret response type
export type WebhookSecretResponse = GetApiResponseByUrl<
  '/v0.1/webhooks/{webhook_id}/secrets',
  'post'
>;

// Webhook status configuration
export const WEBHOOK_STATUS_CONFIG = {
  active: { status: 'success' as const, text: 'Active' },
  paused: { status: 'warning' as const, text: 'Disabled' },
  untested: { status: 'danger' as const, text: 'Action needed' },
} as const;
export type WebhookStatusConfig = typeof WEBHOOK_STATUS_CONFIG;
export type WebhookStatusKey = keyof typeof WEBHOOK_STATUS_CONFIG;

// Derived types for easier usage
export type WebhookEventType = Webhook['event_types'][number];
export type WebhookStatus = Webhook['status'];
export type WebhookFilter = Webhook['filters'][number];
